export const navigationRoutes = [
    {
        ID: "1",
        DisplayName: "Back to eTools",
        NavigationDestination: "/#eTools",
        MenuType: "public",
        MenuID: 1,
        Icon: "TableViewIcon", // Use the component as a value
        DisplayInAdmin: false,
    },
    {
        ID: "2",
        DisplayName: "PTN Home",
        NavigationDestination: "/",
        MenuType: "public",
        MenuID: 1,
        Icon: "HomeIcon",
        DisplayInAdmin: true,
    },
    {
        ID: "3",
        DisplayName: "About",
        NavigationDestination: "/about",
        MenuType: "public",
        MenuID: 1,
        Icon: "InfoIcon",
        DisplayInAdmin: false,
    },
    {
        ID: "4",
        DisplayName: "Help",
        NavigationDestination: "/help",
        MenuType: "public",
        MenuID: 1,
        Icon: "HelpIcon",
        DisplayInAdmin: false,
    },
    {
        ID: "5",
        DisplayName: "Regions",
        NavigationDestination: "/regions",
        MenuType: "public",
        MenuID: 2,
        Icon: "PlaceIcon",
        DisplayInAdmin: false,
    },
    {
        ID: "6",
        DisplayName: "Species",
        NavigationDestination: "/species",
        MenuType: "public",
        MenuID: 2,
        Icon: "SpaIcon",
        DisplayInAdmin: false,
    },
    {
        ID: "7",
        DisplayName: "Map",
        NavigationDestination: "/map",
        MenuType: "public",
        MenuID: 3,
        Icon: "MapIcon",
        DisplayInAdmin: false,
    },
    {
        ID: "8",
        DisplayName: "Login",
        NavigationDestination: "/admin/Dashboard",
        MenuType: "public",
        MenuID: 4,
        Icon: "LoginIcon",
        DisplayInAdmin: false,
    },
    {
        ID: "9",
        DisplayName: "Dashboard",
        NavigationDestination: "/admin/dashboard",
        MenuType: "administration",
        MenuID: 5,
        Icon: "Dashboard",
        DisplayInAdmin: true,
    },
    {
        ID: "10",
        DisplayName: "Users",
        NavigationDestination: "/admin/users",
        MenuType: "administration",
        MenuID: 5,
        Icon: "AdminIcon",
        DisplayInAdmin: false,
    },
    {
        ID: "11",
        DisplayName: "Sites",
        NavigationDestination: "/admin/sites",
        MenuType: "administration",
        MenuID: 5,
        Icon: "MapIcon",
        DisplayInAdmin: true,
    },
    {
        ID: "12",
        DisplayName: "Trials",
        NavigationDestination: "/admin/trials",
        MenuType: "administration",
        MenuID: 5,
        Icon: "Storage",
        DisplayInAdmin: true,
    },
    {
        ID: "13",
        DisplayName: "Trial Results",
        NavigationDestination: "/admin/trial-results",
        MenuType: "administration",
        MenuID: 5,
        Icon: "Grain",
        DisplayInAdmin: true,
    },
    {
        ID: "14",
        DisplayName: "Varieties",
        NavigationDestination: "/admin/varieties",
        MenuType: "administration",
        MenuID: 5,
        Icon: "Grass",
        DisplayInAdmin: true,
    },
    {
        ID: "15",
        DisplayName: "Species",
        NavigationDestination: "/admin/species",
        MenuType: "administration",
        MenuID: 5,
        Icon: "NaturePeople",
        DisplayInAdmin: true,
    },
    {
        ID: "16",
        DisplayName: "Regions",
        NavigationDestination: "/admin/regions",
        MenuType: "administration",
        MenuID: 5,
        Icon: "Public",
        DisplayInAdmin: true,
    },
    {
        ID: "17",
        DisplayName: "Soil Types",
        NavigationDestination: "/admin/soil-types",
        MenuType: "administration",
        MenuID: 5,
        Icon: "Terrain",
        DisplayInAdmin: true,
    },
    {
        ID: "18",
        DisplayName: "Import Data",
        NavigationDestination: "/admin/import-data",
        MenuType: "administration",
        MenuID: 5,
        Icon: "FileDownload",
        DisplayInAdmin: true,
    },
    {
        ID: "19",
        DisplayName: "Site Content",
        NavigationDestination: "/admin/site-content",
        MenuType: "administration",
        MenuID: 5,
        Icon: "Dashboard",
        DisplayInAdmin: true,
    },
    {
        ID: "20",
        DisplayName: "Rainfall Categories",
        NavigationDestination: "/admin/rainfall",
        MenuType: "administration",
        MenuID: 5,
        Icon: "Thunderstorm",
        DisplayInAdmin: true,
    },
    {
        ID: "21",
        DisplayName: "Trial Documents",
        NavigationDestination: "/admin/trial-documents",
        MenuType: "administration",
        MenuID: 5,
        Icon: "Dashboard",
        DisplayInAdmin: true,
    },
    {
        ID: "22",
        DisplayName: "Data Sync",
        NavigationDestination: "/admin/sync",
        MenuType: "administration",
        MenuID: 5,
        Icon: "Sync",
        DisplayInAdmin: true,
    },
    {
        ID: "30",
        DisplayName: "Login",
        NavigationDestination: "#",
        MenuType: "public",
        MenuID: 6,
        Icon: "AdminIcon",
        DisplayInAdmin: true,
    },
    {
        ID: "31",
        DisplayName: "Logout",
        NavigationDestination: "#",
        MenuType: "authenticated",
        MenuID: 6,
        Icon: "Dashboard",
        DisplayInAdmin: true,
    },
];
